// // Income Events
// export const FETCH_INCOME_EVENTS = 'FETCH_INCOME_EVENTS';
// export const FETCH_INCOME_EVENTS_SUCCESS = 'FETCH_INCOME_EVENTS_SUCCESS';
// export const FETCH_INCOME_EVENTS_ERROR = 'FETCH_INCOME_EVENTS_ERROR';
// export const fetchIncomeEvents = () => ({ type: FETCH_INCOME_EVENTS });
// export const fetchIncomeEventsSuccess = (payload: any) => ({ type: FETCH_INCOME_EVENTS_SUCCESS, payload });
// export const fetchIncomeEventsError = (payload: any) => ({ type: FETCH_INCOME_EVENTS_ERROR, payload });

// // Expense Events
// export const FETCH_EXPENSE_EVENTS = 'FETCH_EXPENSE_EVENTS';
// export const FETCH_EXPENSE_EVENTS_SUCCESS = 'FETCH_EXPENSE_EVENTS_SUCCESS';
// export const FETCH_EXPENSE_EVENTS_ERROR = 'FETCH_EXPENSE_EVENTS_ERROR';
// export const fetchExpenseEvents = () => ({ type: FETCH_EXPENSE_EVENTS });
// export const fetchExpenseEventsSuccess = (payload: any) => ({ type: FETCH_EXPENSE_EVENTS_SUCCESS, payload });
// export const fetchExpenseEventsError = (payload: any) => ({ type: FETCH_EXPENSE_EVENTS_ERROR, payload });

export const UPDATE_FUTURE_INCLUDE_IN_SCENARIO = 'UPDATE_FUTURE_INCLUDE_IN_SCENARIO';
export const MODEL_FUTURE_INCLUDE_IN_SCENARIO = 'MODEL_FUTURE_INCLUDE_IN_SCENARIO';
export const SET_INITIAL_FUTURE_INCLUDE_IN_SCENARIO = 'SET_INITIAL_FUTURE_INCLUDE_IN_SCENARIO';

export const updateFutureIncludeInScenario = (data: any) => ({
    type: UPDATE_FUTURE_INCLUDE_IN_SCENARIO,
    payload: data
})

export const modelFutureIncludeInScenario = () => ({
    type: MODEL_FUTURE_INCLUDE_IN_SCENARIO
})

export const setInitialFutureIncludeInScenario = (data: any) => ({
    type: SET_INITIAL_FUTURE_INCLUDE_IN_SCENARIO,
    payload: data
})